import { Component, OnInit, Input } from '@angular/core';
import { SideMenuService } from '../side-menu/side-menu.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss']
})
export class DefaultHeaderComponent implements OnInit {

  constructor(private sideMenuService: SideMenuService,
              private translateService: TranslateService) { }

  @Input() set AppName(value: string){
    this.translateService.get(value)
      .subscribe(translate => this._appName = translate);
  }

  _appName: string;

  @Input() LogoLink: string;
  @Input() OpenLogoInNewTab = true;
  @Input() BazaZnanjaLink: string;

  ngOnInit() {
  }

  SetSideMenuCollapse(){
    this.sideMenuService.SetSideMenuCollapse();
  }

}
